import { UserService } from '../../../services/user.service';
import { ActivatedRoute } from '@angular/router';
import { Kpi } from '../../../../models/common';
import { InfluencerService } from '../../../services/influencer/influencer.service';
import { PostListComponent } from '../../influencer/post-list/post-list.component';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { CommonConstant } from '../../../app.constants';
import { CampaignService } from '../../../services/campaign/campaign.service';
export var ServiceCounter;
(function (ServiceCounter) {
    ServiceCounter[ServiceCounter["staticComponents"] = 5] = "staticComponents";
    ServiceCounter[ServiceCounter["renderTimeout"] = 500] = "renderTimeout";
})(ServiceCounter || (ServiceCounter = {}));
var CampaignPdfViewerComponent = /** @class */ (function () {
    function CampaignPdfViewerComponent(userService, activatedRoute, influencerService, campaignService, pdfExportService) {
        this.userService = userService;
        this.activatedRoute = activatedRoute;
        this.influencerService = influencerService;
        this.campaignService = campaignService;
        this.pdfExportService = pdfExportService;
    }
    CampaignPdfViewerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activatedRoute.params.subscribe(function (params) {
            _this.campaignInfluencerId = Number(params.campaignInfluencerId);
        });
        var currentInfluencer = this.userService.getInfluencerInfo();
        if (currentInfluencer) {
            this.getInfluencerDetails(currentInfluencer.id);
            this.getInfluencerPosts(currentInfluencer.id);
            this.loadDetailsCampaignInfluencer(this.campaignInfluencerId);
        }
        this.numOfReportComponent = ServiceCounter.staticComponents;
        this.pdfExportService.triggerIncrementReportReady.subscribe(function (numberReportReady) {
            if (numberReportReady === _this.numOfReportComponent) {
                console.log(' ***************************************** CAMPAIGN READY TO EXPORT PDF *****************************************');
                setTimeout(function () {
                    _this.pdfReady();
                }, ServiceCounter.renderTimeout);
            }
        });
    };
    CampaignPdfViewerComponent.prototype.pdfReady = function () {
        if (window && typeof window.pdfReady === 'function') {
            setTimeout(function () {
                window.pdfReady();
            }, ServiceCounter.renderTimeout);
        }
    };
    CampaignPdfViewerComponent.prototype.getInfluencerDetails = function (influencerId) {
        var _this = this;
        this.influencerService.getInfluencer(influencerId).subscribe(function (data) {
            _this.influencer = data;
        });
    };
    CampaignPdfViewerComponent.prototype.loadDetailsCampaignInfluencer = function (campaignInfluencerId) {
        this.getCampaignInfluencerDetail(campaignInfluencerId);
        this.getCampaignBelongedToInfluencer(campaignInfluencerId);
    };
    CampaignPdfViewerComponent.prototype.getCampaignInfluencerDetail = function (campaignInfluencerId) {
        var _this = this;
        this.influencerService.getCampaignInfluencerDetail(campaignInfluencerId).subscribe(function (res) {
            if (res && res.campaign) {
                _this.campaign = res.campaign;
            }
        });
    };
    CampaignPdfViewerComponent.prototype.getCampaignBelongedToInfluencer = function (campaignInfluencerId) {
        this.getCampaignInfluencerData(campaignInfluencerId);
    };
    CampaignPdfViewerComponent.prototype.getCampaignInfluencerData = function (campaignInfluencerId) {
        var _this = this;
        this.influencerService.getCampaignInfluencerData(campaignInfluencerId)
            .subscribe(function (res) {
            // parse KPI
            var postKpi = new Kpi();
            postKpi.engagement.value = res.globalChannelKpi.engagement;
            postKpi.impact.value = res.globalChannelKpi.impact * 100;
            postKpi.impressions.value = res.globalChannelKpi.impression;
            postKpi.reach.value = res.globalChannelKpi.reach;
            postKpi.post.value = res.globalChannelKpi.post;
            _this.campaignInfluencerKPI = postKpi;
            // parse post list
            var postList = res.postList.map(function (post) { return ({
                imageUrl: post.image,
                title: post.page_title,
                date: post.date,
                relativePath: post.relativePath,
                fullUrl: post.full_url,
                platformBlogs: post.platformBlogs,
                platformInstagram: post.platformInstagram,
                platformYoutube: post.platformYoutube,
                platformSnapchat: post.platformSnapchat,
                platformTwitter: post.platformTwitter,
                platformPinterest: post.platformPinterest,
                platformFacebook: post.platformFacebook,
                reach: post.reach.value,
                engagement: post.engagement.value,
                impressions: post.impression && post.impression.value > 0 ? post.impression.value : post.reach.value,
                impact: post.impact.value,
                urlHash: post.urlHash
            }); });
            _this.campaignPosts = postList;
            _this.calculateCampaignPostPage(postList.length);
            _this.getCampaignPostDailyKpis(postList);
        });
    };
    CampaignPdfViewerComponent.prototype.calculateCampaignPostPage = function (numOfList) {
        var totalFullPage = Math.floor(numOfList / CampaignPdfViewerComponent.MAX_POST_ITEM);
        var hasPartialPage = (numOfList % CampaignPdfViewerComponent.MAX_POST_ITEM) > 0;
        var numberOfCampaignPostPage;
        if (hasPartialPage) {
            numberOfCampaignPostPage = totalFullPage + 1;
        }
        else {
            numberOfCampaignPostPage = totalFullPage;
        }
        this.campaignPostPages = new Array(numberOfCampaignPostPage);
        this.numOfReportComponent += numberOfCampaignPostPage;
    };
    CampaignPdfViewerComponent.prototype.getCampaignPostDailyKpis = function (campaignPosts) {
        var _this = this;
        if (!campaignPosts || campaignPosts.length === 0) {
            this.campaignPostDailyKpis = [];
            return;
        }
        var orderedPosts = campaignPosts.sort(function (p1, p2) {
            var startDate1 = new Date(p1.date);
            var startDate2 = new Date(p2.date);
            return startDate1.getTime() - startDate2.getTime();
        });
        var fromDate = orderedPosts[0].date;
        var toDate = orderedPosts[orderedPosts.length - 1].date;
        this.campaignService.getCampaignPostDailyKpis(this.campaignInfluencerId, fromDate, toDate).subscribe(function (res) {
            _this.campaignPostDailyKpis = res;
        });
    };
    CampaignPdfViewerComponent.prototype.getInfluencerPosts = function (influencerId) {
        var _this = this;
        var postListParams = {
            date: CommonConstant.PERIOD_30_DAYS,
            limit: CommonConstant.LIMIT_20,
        };
        this.influencerService.getInfluencerPosts(influencerId, postListParams)
            .subscribe(function (data) {
            data.forEach(function (item) {
                item.title = item.title.replace(/\uFFFD/g, ''); // remove unknown character
                item.title = item.title.substring(0, 100) + '...'; // get 100 characters
            });
            _this.influencerPostList = data;
            // if no posts, post list pdf module should be activated immediately
            if (_this.influencerPostList.length === 0) {
                _this.pdfExportService.incrementNumberReportReady(PostListComponent.COMPONENT_NAME);
            }
        });
    };
    CampaignPdfViewerComponent.prototype.getSubPostList = function (pageNo) {
        var startIndex = pageNo * CampaignPdfViewerComponent.MAX_POST_ITEM;
        return this.campaignPosts.slice(startIndex, startIndex + CampaignPdfViewerComponent.MAX_POST_ITEM);
    };
    Object.defineProperty(CampaignPdfViewerComponent.prototype, "canShowCampaignKpi", {
        get: function () {
            return this.campaignInfluencerKPI;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignPdfViewerComponent.prototype, "canShowInfluencerPostList", {
        get: function () {
            return this.influencerPostList && this.influencerPostList.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    CampaignPdfViewerComponent.MAX_POST_ITEM = 8;
    return CampaignPdfViewerComponent;
}());
export { CampaignPdfViewerComponent };



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/campaign-pdf-viewer/campaign-pdf-viewer.component.ts.pre-build-optimizer.js